import React, { useState, useEffect } from 'react'
import './App.scss'
import axios from 'axios'
import socket from './modules/socket'
import { SPContext } from './SPContext'
import Header from './components/header/Header'
import Body from './components/body/Body'
import EventView from './components/event/EventView'
import Admin from './components/admin/Admin'
import Footer from './components/footer/Footer'
import EventModalEdit from './components/modal/EventModalEdit'
import ScrollToTop from './components/helpers/ScrollToTop'
import Login from './components/login/Login'
import { Switch, Route } from 'react-router-dom'
import '@fortawesome/fontawesome-free/css/all.css'
import { UncontrolledAlert } from 'reactstrap'
import { Link } from 'react-router-dom'

const token = localStorage.getItem('token')
// console.log({ token })

const notifications_content_list = [
    {
        id: '1',
        content: 'A new event has been created. Click the link for more information.',
    },
    {
        id: '2',
        content: 'An event has been updated. Click the link for more information.',
    },
]

function App() {
    const uri = '/api/'
    const [authStatus, setAuthStatus] = useState('waiting_for_auth_check')
    const [appStatus, setAppStatus] = useState('waiting_for_data')
    const [isLoggedIn, setIsLoggedIn] = useState(false)
    const [events, setEvents] = useState([])
    const [event_types, setEventTypes] = useState([])
    const [categories, setCategories] = useState([])
    const [locations, setLocations] = useState([])
    const [users, setUsers] = useState([])
    const [event_status, setEventStatus] = useState([])
    const [user_id, setUserId] = useState(null)
    const [filter, setFilter] = useState([])
    const [sort, setSort] = useState('ENDING_FIRST')
    const [didMount, setDidMount] = useState(false)
    const [user_data, setUserData] = useState({})
    const [iLikeEvent, setLikeEvent] = useState([])
    const [page, setPage] = useState(1)

    const [isAdmin, setIsAdmin] = useState(false)
    const [inAdminPage, setInAdminPage] = useState(false)

    // console.log({ user_data }, { appStatus }, { authStatus })
    useEffect(() => {
        if (!isLoggedIn) {
            if (authStatus === 'waiting_for_auth_check' && token) {
                socket
                    .verify(token)
                    .then(r => {
                        if (r.success && r.user_data && r.user_data.is_plan) {
                            setUserData(r.user_data)
                            setUserId(r.user_data.user_id)
                            setIsLoggedIn(true)

                            if (
                                !!r.user_data.plan_user_roles.find(
                                    user_role => user_role === 230000,
                                )
                            ) {
                                setIsAdmin(true)
                            } else {
                                setIsAdmin(false)
                            }
                            setInAdminPage(false)
                        }
                        authStatus === 'waiting_for_auth_check' && setAuthStatus('auth_checked')
                    })
                    .catch(err => {
                        console.error(err)
                        authStatus === 'waiting_for_auth_check' && setAuthStatus('auth_checked')
                    })
            } else if (!token) {
                authStatus === 'waiting_for_auth_check' && setAuthStatus('auth_checked')
            }
        }
    })

    const quickGet = url => axios.get(url + '?token=' + user_data.token)

    if (!didMount && isLoggedIn) {
        let then_array = []
        const get_events = quickGet(`${uri}Event`)
        then_array.push(response => {
            let event_data = Object.keys(response.data.data).map(key => {
                response.data.data[key].notification_notified_user_list = response.data.data[key]
                    .notification_notified_user_list
                    ? response.data.data[key].notification_notified_user_list.split(',')
                    : null
                return response.data.data[key]
            })
            setEvents(event_data)
        })

        const get_event_price_type = quickGet(`${uri}Event_Price_Type`)
        then_array.push(response => {
            setEventTypes(response.data.data)
        })

        const get_categories = quickGet(`${uri}Category`)
        then_array.push(response => {
            setCategories(response.data.data)
        })

        const get_locations = quickGet(`${uri}Location`)
        then_array.push(response => {
            setLocations(response.data.data)
        })

        const get_users = quickGet(`${uri}User`)
        then_array.push(response => {
            setUsers(response.data.data)
        })

        const get_event_status = quickGet(`${uri}Event_Status`)
        then_array.push(response => {
            setEventStatus(response.data.data[0])
        })

        Promise.all([
            get_events,
            get_event_price_type,
            get_categories,
            get_locations,
            get_users,
            get_event_status,
        ])
            .then(values => values.map((response, index) => then_array[index](response)) || values)
            .then(() => setAppStatus('ready'))

        setDidMount(true)
    }

    const default_event = {
        event_id: 0,
        event_FK_event_status_id: 4,
        event_FK_event_price_type_id: -1,
        event_featured_flag: false,
        event_title: '',
        event_FK_event_summary_id: 0,
        event_FK_event_description_id: 0,
        event_date_start: '',
        event_response_deadline: '',
        event_needed_min: 0,
        event_needed_max: '',
        event_FK_location_id: -1,
        event_map_link: '',

        event_holiday_required: false,
        event_holiday_work_days: '',

        event_family_welcome: false,
        event_age_limit: -1,
        event_friends_welcome: false,

        event_company_contribution_per_person: 0,
        event_company_contribution: '',
        event_cost_individual: 0,
        event_related_website: '',

        event_description_value: '',
        event_summary_value: '',

        event_status_label: '',
        going_length: '',
        likes_length: '',
    }

    const [isOpen, setIsOpen] = useState(false)
    const [isViewOpen, setIsViewOpen] = useState(false)
    const [eventId, setEventId] = useState(-1)
    const [event, setEvent] = useState(default_event)

    const gotoGallery = (e, view_create, event_id) => {
        window.open('https://plancom.sharepoint.com/sites/playplan', 'gallery')
    }
    const handleOpenEventModal = (e, view_create, event_id) => {
        // debugger
        const my_event = events.find(event_item => {
            return parseInt(event_item.event_id, 10) === parseInt(event_id, 10)
        })

        // if (
        //   my_event &&
        //   parseInt(my_event.event_FK_created_by_user_id, 10) === user_id
        // ) {
        //   view_create = 'editing'
        // }

        if (view_create === 'view') {
            if (!isViewOpen) {
                setEventId(event_id)
                setEvent(my_event)
            }
            setIsViewOpen(!isViewOpen)
        } else {
            if (!isOpen) {
                setEventId(event_id)
                setEvent(view_create === 'editing' ? my_event : default_event)
            }
            setIsOpen(!isOpen)
        }
    }

    const eventInterestedPost = (event_id, inout, diff_user_id) => {
        inout = inout ? true : false

        let data = new FormData()
        data.append('event_id', event_id)
        data.append('action', inout)
        data.append('token', user_data.token)

        if (diff_user_id) {
            data.append('diff_user_id', diff_user_id)
        }

        axios
            .post(`${uri}Event_Interested/save`, data)
            .then(response => {
                if (inout) {
                    const candidate = { ...events.find(e => e.event_id === event_id) }
                    candidate.interested =
                        (candidate.interested && [
                            ...candidate.interested.filter(uid => uid !== user_id),
                        ]) ||
                        []
                    candidate.interested.push(user_id)
                    setEvents(
                        events.reduce((acc, e) => {
                            if (e.event_id !== event_id) {
                                acc.push(e)
                            } else {
                                acc.push(candidate)
                            }
                            return acc
                        }, []),
                    )
                } else {
                    eventInterestedPostOut(event_id, user_id, null)
                }
            })
            .then(err => {
                console.log(err)
            })
    }

    const eventInterestedPostOut = (event_id, diff_user_id, candidate_going) => {
        const candidate = { ...events.find(e => e.event_id === event_id) }
        candidate.interested =
            (candidate.interested && [
                ...candidate.interested.filter(uid => uid !== (diff_user_id || user_id)),
            ]) ||
            []

        if (candidate_going !== null) {
            candidate.going = candidate_going
        }

        setEvents(
            events.reduce((acc, e) => {
                if (e.event_id !== event_id) {
                    acc.push(e)
                } else {
                    acc.push(candidate)
                }
                return acc
            }, []),
        )
    }

    const eventGoingPost = (event_id, inout, diff_user_id) => {
        // console.log(event, user_id, inout)

        inout = inout ? true : false

        let data = new FormData()
        data.append('event_id', event_id)
        data.append('action', inout)
        data.append('token', user_data.token)

        if (diff_user_id) {
            data.append('diff_user_id', diff_user_id)
        }

        axios
            .post(`${uri}Event_Going/save`, data)
            .then(response => {
                if (inout) {
                    const candidate = { ...events.find(e => e.event_id === event_id) }

                    candidate.going =
                        (candidate.going && [
                            ...candidate.going.filter(uid => uid !== (diff_user_id || user_id)),
                        ]) ||
                        []
                    candidate.going.push(diff_user_id || user_id)

                    if (response.data.interested.length > 0) {
                        eventInterestedPostOut(
                            event_id,
                            parseInt(
                                response.data.interested[0]['event_interested_FK_user_id'],
                                10,
                            ), //diff_user_id || user_id
                            candidate.going,
                        )
                    } else {
                        setEvents(
                            events.reduce((acc, e) => {
                                if (e.event_id !== event_id) {
                                    acc.push(e)
                                } else {
                                    acc.push(candidate)
                                }
                                return acc
                            }, []),
                        )
                    }
                } else {
                    const candidate = { ...events.find(e => e.event_id === event_id) }
                    candidate.going =
                        (candidate.going && [
                            ...candidate.going.filter(uid => uid !== (diff_user_id || user_id)),
                        ]) ||
                        []
                    setEvents(
                        events.reduce((acc, e) => {
                            if (e.event_id !== event_id) {
                                acc.push(e)
                            } else {
                                acc.push(candidate)
                            }
                            return acc
                        }, []),
                    )
                }
            })
            .catch(err => {
                console.log(err)
            })
    }
    const eventLikePost = (event_id, inout) => {
        // console.log(event, user_id, inout)

        inout = inout ? true : false

        let data = new FormData()
        data.append('event_id', event_id)
        data.append('action', inout)
        data.append('token', user_data.token)

        axios
            .post(`${uri}Event_Like/save`, data)
            .then(response => {
                if (inout) {
                    const candidate = { ...events.find(e => e.event_id === event_id) }
                    candidate.likes = [...candidate.likes]
                    candidate.likes.push(user_id)
                    setEvents(
                        events.reduce((acc, e) => {
                            if (e.event_id !== event_id) {
                                acc.push(e)
                            } else {
                                acc.push(candidate)
                            }
                            return acc
                        }, []),
                    )
                } else {
                    const candidate = { ...events.find(e => e.event_id === event_id) }
                    candidate.likes = [...candidate.likes.filter(uid => uid !== user_id)]
                    setEvents(
                        events.reduce((acc, e) => {
                            if (e.event_id !== event_id) {
                                acc.push(e)
                            } else {
                                acc.push(candidate)
                            }
                            return acc
                        }, []),
                    )
                }
                // let axios_ilikeevent
                // if (inout) {
                //   axios_ilikeevent = [...iLikeEvent, event.event_id]
                // } else {
                //   axios_ilikeevent = [...iLikeEvent]
                //   axios_ilikeevent = axios_ilikeevent.filter(
                //     item => parseInt(item, 10) !== parseInt(event.event_id, 10),
                //   )
                // }

                // setLikeEvent(axios_ilikeevent)
            })
            .catch(err => {
                console.error(err)
            })
    }

    if (inAdminPage && window.location.href.indexOf('admin') === -1) {
        setInAdminPage(false)
    }
    if (!inAdminPage && window.location.href.indexOf('admin') > -1) {
        setInAdminPage(true)
    }
    if (!inAdminPage && filter.status && filter.status.filter(sId => sId !== '5').length > 0) {
        setFilter({ ...filter, status: filter.status.filter(sId => sId === '5') })
    }

    // const [showNotifications, setShowNotifications] = useState(false)
    const [showNotifications] = useState(false)
    const [notifications, setNotifications] = useState([])

    useEffect(() => {
        if (showNotifications) {
            setNotifications(
                events
                    .filter(
                        e =>
                            // parseInt(e.event_id, 10) >= 167 &&
                            e.notification_notified_user_list &&
                            !e.notification_notified_user_list.includes(user_id.toString()),
                    )
                    .reduce((acc: any[], r_event: any) => {
                        const notification_content =
                            r_event.notification_FK_notification_type_id &&
                            notifications_content_list.find(
                                n => n.id === r_event.notification_FK_notification_type_id,
                            )

                        return [
                            ...acc,
                            {
                                event_id: r_event.event_id,
                                label: notification_content
                                    ? notification_content.content
                                    : r_event.notification_type_label,
                                color: r_event.notification_type_color,
                            },
                        ]
                    }, []),
            )
        }
    }, [events])
    // console.log('trabuco:notifications', notifications)

    // const notifications = [
    //     { event_id: '167', label: 'new event', color: 'success' },
    //     { event_id: '167', label: 'event changed', color: 'warning' },
    //     {
    //         event_id: '167',
    //         label: 'the event you have signed up for is approaching',
    //         color: 'danger',
    //     },
    //     { event_id: '167', label: 'event changed', color: 'warning' },
    //     { event_id: '167', label: 'event changed', color: 'warning' },
    //     {
    //         event_id: '167',
    //         label: 'the event you have signed up for is approaching',
    //         color: 'danger',
    //     },
    // ]

    return (
        <SPContext.Provider
            value={{
                authStatus,
                setAuthStatus,
                appStatus,
                isLoggedIn,
                setIsLoggedIn,
                setUserId,
                setUserData,
                token: (user_data && user_data.token) || '',
                user_data,
                user_id,
                uri,
                filter,
                setFilter,
                sort,
                setSort,
                event_types,
                categories,
                locations,
                users,
                event_status,
                events,
                setEvents,
                event,
                setEvent,
                eventId,
                isOpen,
                isViewOpen,
                handleOpenEventModal,
                gotoGallery,
                eventGoingPost,
                eventInterestedPost,
                iLikeEvent,
                setLikeEvent,
                eventLikePost,
                page,
                setPage,
                isAdmin,
                setIsAdmin,
                inAdminPage,
                setInAdminPage,
            }}
        >
            <div
                className={
                    'app' +
                    ((authStatus === 'auth_checked' && !isLoggedIn && ' login') || '') +
                    (((authStatus === 'waiting_for_auth_check' ||
                        (isLoggedIn && appStatus !== 'ready')) &&
                        ' loading') ||
                        '')
                }
            >
                {(isLoggedIn && appStatus === 'ready' && <Header />) || null}

                <ScrollToTop />
                {(authStatus === 'auth_checked' && !isLoggedIn && <Login />) || null}
                {(isLoggedIn && events && (
                    <>
                        {showNotifications &&
                            events &&
                            events.length > 0 &&
                            notifications.map((n: any, ix: number) => {
                                const alert_event =
                                    events && events.find(e => e.event_id === n.event_id)
                                return (
                                    <UncontrolledAlert
                                        key={`notifications-${n.event_id}-${ix}`}
                                        className='sp-event-modal-alert-notification'
                                        // isOpen={is_notification_open}
                                        // toggle={toggleNotification}
                                        color={n.color}
                                    >
                                        {n.label}{' '}
                                        <Link to={`/event/view/${n.event_id}`}>
                                            {(alert_event && alert_event.event_title) ||
                                                'click here'}
                                        </Link>
                                    </UncontrolledAlert>
                                )
                            })}

                        <Switch>
                            <Route path='/' exact component={Body} />
                            <Route path='/event/view/:id' component={EventView} />
                            <Route path='/admin' component={Admin} />
                        </Switch>
                    </>
                )) ||
                    null}
                {(isLoggedIn && appStatus === 'ready' && <Footer />) || null}
                <EventModalEdit className={''} />
            </div>
        </SPContext.Provider>
    )
}

export default App
